import React from 'react';
import { View } from 'react-native';

import ColorsWrapper from '@styles/colors';

import NCFileDetails from '@components/ncFiles/ncFileDetails';

const PanelViewProperties = (props) => {
  const params = props?.route?.params || {};
  return (
    <View style={{ width: '100%', height: '100%' }}>
      <NCFileDetails {...{ ...props, ...params, panelViewMode: true }} />
    </View>
  );
};

export default ColorsWrapper(PanelViewProperties);
